import { render } from "./new_password.vue?vue&type=template&id=6e591e23"
import script from "./new_password.vue?vue&type=script&lang=js"
export * from "./new_password.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__